import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { toast } from 'sonner';

export default function FooterCta() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email.');
      return;
    }
    setBusy(true);
    setTimeout(() => {
      const existing = JSON.parse(localStorage.getItem('sc_waitlist') || '[]');
      if (!existing.includes(email)) existing.push(email);
      localStorage.setItem('sc_waitlist', JSON.stringify(existing));
      toast.success("You're on the list.");
      setEmail('');
      setBusy(false);
    }, 400);
  };

  return (
    <footer className="relative border-t border-black/5 bg-[#EFEAE1]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 py-24 md:py-32">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-serif text-[36px] md:text-[56px] leading-[1.02] tracking-[-0.02em] text-neutral-900">
            Be there for <span className="italic">issue 001.</span>
          </h2>
          <p className="mt-6 text-neutral-600 text-[15px] md:text-[17px]">
            The first story drops the week we launch. Get it before anyone
            else.
          </p>

          <form
            onSubmit={submit}
            className="mt-10 flex items-stretch max-w-lg mx-auto"
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@domain.com"
              className="flex-1 bg-transparent border-b border-neutral-400/60 focus:border-neutral-900 outline-none px-1 py-3 text-[15px] text-neutral-900 placeholder:text-neutral-400 transition-colors"
            />
            <button
              type="submit"
              disabled={busy}
              className="ml-3 group inline-flex items-center gap-2 bg-neutral-900 hover:bg-[#EA580C] text-[#F5F2EC] px-5 py-3 text-[13px] tracking-wide rounded-sm transition-colors duration-300 disabled:opacity-60"
            >
              {busy ? 'Joining…' : 'Join waitlist'}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
            </button>
          </form>
        </div>

        <div className="mt-20 pt-6 border-t border-black/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-[11px] tracking-[0.22em] uppercase text-neutral-500">
            © 2026 Startup Culture
          </div>
          <div className="flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-neutral-500">
            <span className="h-1.5 w-1.5 rounded-full bg-[#EA580C]" />
            Formerly
            <a
              href="https://www.linkedin.com/company/confidential-company-page12/"
              target="_blank"
              rel="noreferrer"
              className="underline underline-offset-4 decoration-neutral-400 hover:text-neutral-900 hover:decoration-neutral-900 transition-colors"
            >
              Confidential
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
